<template>
<div id="main-pane">
    <div id="left-pane">
        <div class="top-content">
            <nav class="navbar navbar-inverse sidebar-header" role="navigation">
                <img src="static/images/gig_logo_line.png" alt="Neocom Logo">
                <button class="layer-indicator"></button>
            </nav>
        </div>
        <div class="middle-content">
            <div class="login-container">
                <form id="form-signin" role="form">
                    <h4 class="form-signin-heading">{{ i18n('Action.SignIn') }}</h4>
                    <div class="form-group">
                        <input type="email" class="form-control flat" maxlength="256" placeholder="E-mail"
                               name="username" required autofocus>
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control flat" :placeholder="i18n('Common.Password')"
                               name="password"
                               required>
                    </div>
                    <button class="btn btn-lg btn-inverse btn-block" type="submit">{{ i18n('Action.SignIn') }}</button>
                    <div class="form-group">
                        <button id="reset-pass-link" class="btn btn-link" type="button">{{
                            i18n('Common.NeedHelp')}}
                        </button>
                    </div>
                </form>
            </div>
            <div class="need-help-container">
                <form id="form-need-help" role="form">
                    <h5 class="form-signin-heading">{{ i18n('Common.NeedHelp').toUpperCase() }}</h5>
                    <div class="form-group">
                        <label>
                            <input type="radio" name="help" value="1"> {{ i18n('Common.ForgotPassword') }}
                        </label>
                        <label>
                            <input type="radio" name="help" value="2"> {{ i18n('Message.RecoverCode') }}
                        </label>
                    </div>
                    <div class="form-group">
                        <button class="btn btn-lg btn-default btn-block" type="reset">{{ i18n('Action.Back') }}
                        </button>
                        <button class="btn btn-lg btn-inverse btn-block" type="submit">{{ i18n('Action.Forward')}}
                        </button>
                    </div>
                </form>
            </div>
            <div class="reset-token-container">
                <form id="form-reset-token" role="form">
                    <h5 class="form-signin-heading">{{ i18n('Message.RecoverCode').toUpperCase() }}</h5>
                    <div class="form-group">
                        <input type="text" class="form-control flat" :placeholder="i18n('Common.RecoverCode')"
                               name="Token" required>
                    </div>
                    <div class="form-group">
                        <input type="email" class="form-control flat" maxlength="256" placeholder="E-mail"
                               name="Email" required>
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control flat" :placeholder="i18n('Common.NewPassword')"
                               name="Password"
                               required
                               data-toggle="popover" data-html="true" data-trigger="hover"
                               title="Segurança de Senha"
                               data-placement="bottom">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control flat"
                               :placeholder="i18n('Common.PasswordConfirmation')"
                               name="ConfirmPassword"
                               required>
                    </div>
                    <div class="form-group">
                        <button class="btn btn-lg btn-default btn-block" type="reset">{{ i18n('Action.Back') }}
                        </button>
                        <button class="btn btn-lg btn-inverse btn-block" type="submit">{{ i18n('Action.Forward')}}
                        </button>
                    </div>
                </form>
            </div>
            <div class="sidebar-container" id="sidebar-container"></div>
            <div class="backdrop"></div>
        </div>
        <div class="bottom-content">
            <div class="client-selection-container" id="client-selection-container"></div>
            <div class="flag-settings"></div>
            <div class="user-settings dropdown dropup">
                <span id="user-info" class="dropdown-toggle" data-toggle="dropdown">
                    <i class="fa fa-ellipsis-h"></i>
                </span>
                <!-- <button id="user-actions" type="button" class="btn btn-link dropdown-toggle" data-toggle="dropdown"
                        title="Opções" style="color: #34495e;"><i class="fa fa-ellipsis-h"></i>
                </button> -->
                <ul class="dropdown-menu" role="menu">
                    <li><a @click="saveSnapshot" href="#">{{ i18n('Action.SaveSnapshot') }}</a></li>
                    <li><a @click="loadSnapshot" href="#">{{ i18n('Action.LoadSnapshot') }}</a></li>
                    <li><a @click="restoreSnapshot" href="#">{{ i18n('Action.LoadLastSnapshot') }}</a></li>
                    <li><a id="control-panel" href="#">Painel de Controle</a></li>
                    <li>
                        <router-link :to="{ name: 'endUserAgreement' }" target="_blank">
                            {{ i18n('Action.EndUserAgreement') }}
                        </router-link>
                    </li>
                    <li><a @click="logout" href="#">{{ i18n('Action.SignOut') }}</a></li>
                    <li><a id="manual" @click.prevent="openManual" href="#">Manual</a></li>
                </ul>
            </div>
        </div>
    </div>
    <div id="center-pane">
        <div class="top-content">
            <nav ref="navbar" class="navbar navbar-inverse" role="navigation">
                <button type="button" id="trigger-sidebar" class="btn btn-link sidebar-toggle"
                        :title="i18n('Action.ToggleLayerMenu')">
                    <i class="fa fa-2x fa-bars"></i>
                </button>
                <div id="navbar-search" class="navbar-search"></div>
                <a href="/" class="navbar-logo">
                    <img id="btn-reload" src="static/images/gig_logo.png" alt="Logo NeoGIG" class="gig-logo"/>
                </a>
                <div ref="navbarActions" class="navbar-actions">
                    <div class="dropdown">
                        <button id="language-selection" class="btn btn-link dropdown-toggle" data-toggle="dropdown"
                                aria-expanded="false" :title="i18n('Action.ChangeLanguage')">
                            {{ language.toUpperCase() }}
                        </button>
                        <ul class="dropdown-menu dropdown-menu-inverse" role="menu"
                            style="min-width: 32px; text-align: center; font-size: 1.75rem;">
                            <li :title="i18n('Portuguese')" @click="setLanguage('pt-BR')">
                                <a @click.prevent class="link-change-lang">
                                    <img src="../../static/images/flag-brazil.svg" style="width: 2rem; margin-right: 1rem;"/>
                                    {{ i18n('Portuguese') }}</a></li>
                            <li :title="i18n('Spanish')" @click="setLanguage('es-AS')">
                                <a @click.prevent class="link-change-lang">
                                    <img src="../../static/images/flag-spanish.svg" style="width: 2rem; margin-right: 1rem;"/>
                                    {{ i18n('Spanish') }}</a></li>
                            <li :title="i18n('English')" @click="setLanguage('en-AS')">
                                <a @click.prevent class="link-change-lang">
                                    <img src="../../static/images/flag-united-states.svg" style="width: 2rem; margin-right: 1rem;"/>
                                    {{ i18n('English') }}</a></li>
                        </ul>
                    </div>
                    <button @click.prevent="openManual" id="trigger-manual" class="btn btn-link navbar-collapsible"
                            :title="i18n('Action.UserManual')" target="_blank" style="display: none;">
                        <i class="fa fa-2x fa-book"></i>
                    </button>
                    <div class="dropdown" style="display: none;">
                        <button id="tool-selection" class="btn btn-link dropdown-toggle" data-toggle="dropdown"
                                aria-expanded="false" :title="i18n('Action.ToggleSelectionTools')">
                            <i class="fa fa-2x fa-mouse-pointer"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-inverse" role="menu"
                            style="min-width: 32px; text-align: center; font-size: 1.75rem;">
                            <li title="Rectangle" @click="drawRectangle"><a @click.prevent><i class="fa fa-square"></i></a>
                            </li>
                            <li title="Circle" @click="drawCircle"><a @click.prevent><i class="fa fa-circle"></i></a>
                            </li>
                            <li title="Polygon" @click="drawPolygon"><a @click.prevent><i class="fa fa-star"></i></a>
                            </li>
                            <li id="tool-selection-remove" title="Remove"><a @click.prevent><i class="fa fa-trash"></i></a>
                            </li>
                        </ul>
                    </div>
                    <button type="button" id="trigger-map-capture" class="btn btn-link navbar-collapsible"
                            :title="i18n('Action.ScreenCapture')" style="display: none;">
                        <i class="fa fa-2x fa-camera"></i>
                    </button>
                    <button type="button" id="trigger-compare" class="btn btn-link navbar-collapsible"
                            :title="i18n('Action.ToggleCompareMaps')"
                            style="display: none;">
                        <i class="fa fa-2x fa-columns"></i>
                    </button>
                    <a id="trigger-dashboard" type="button"
                       class="btn btn-link navbar-collapsible"
                       :title="i18n('Action.ReportsCenter')"
                       target="_blank"
                       :href="neodashUrl"
                       style="display: none;"><i class="fa fa-2x fa-line-chart"></i></a>
                    <navbar-overflow></navbar-overflow>
                    <button type="button" id="trigger-infoboard" class="btn btn-link infoboard-toggle"
                            :title="i18n('Action.ToggleInfoboardPanel')">
                        <i class="fa fa-2x fa-chevron-left"></i>
                    </button>
                </div>
            </nav>
        </div>
        <div class="middle-content">
            <div id="map-blur" class="map-blur">
                <div class="site-wrapper">
                    <div class="site-wrapper-inner">
                        <div class="cover-container">
                            <div class="inner cover">
                                <h2 class="cover-heading">{{ i18n('Common.Welcome') }}</h2>
                                <p v-html="i18n('Message.Welcome')"></p>
                                <!--<a class="btn btn-option btn-link">Sign-In</a>-->
                            </div>
                            <div class="mastfoot">
                                <div class="inner">
                                    ©{{ moment().format('YYYY') }} Neocom, Ltda. ·
                                    <router-link :to="{ name: 'endUserAgreement' }" target="_blank">{{
                                        i18n('Common.Privacy') }}
                                    </router-link>
                                    ·
                                    <router-link :to="{ name: 'endUserAgreement' }" target="_blank">{{
                                        i18n('Common.Terms') }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="map-container" class="map-container on-left"></div>
        </div>
        <div class="bottom-content">
            <div id="dash-container" class="dash-container"></div>
            <div id="databoard-container" class="databoard-container"></div>
            <div id="blog-container" class="dash-container"></div>
            <div id="dnc-container" class="dash-container"></div>
            <div id="filter-container" class="filter-container"></div>
            <div id="image-container" class="dash-container"></div>
            <div id="kendo-dialog"></div>
        </div>
    </div>
    <div id="right-pane">
        <div class="top-content">
            <nav class="navbar navbar-inverse" role="navigation">
                <div class="btn-group" style="margin: 6px 0 0 8px;">
                    <div class="btn-group">
                        <button type="button" class="btn btn-inverse dropdown-toggle" data-toggle="dropdown"
                                id="infoboard-tabs-button" title="Contexto"> {{ i18n('Common.Layers') }}
                            <i class="fa fa-caret-down"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-inverse" id="infoboard-tabs">
                        </ul>
                    </div>
                </div>
                <div id="infoboard-actions" class="btn-group navbar-right"
                     style="margin: 0 6px 0 0; display: none;">
                    <div class="btn-group">
                        <button type="button" class="btn btn-link btn-inverse dropdown-toggle"
                                data-toggle="dropdown"
                                id="infoboard-actions-button" title="Ações">
                            <i class="fa fa-2x fa-ellipsis-v" aria-hidden="true"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-inverse">
                            <li><a data-target="select_all">{{ i18n('Action.SelectAll') }}</a></li>
                            <li><a data-target="select_inverse">{{ i18n('Action.SelectInverse') }}</a></li>
                            <li><a data-target="select_none">{{ i18n('Action.SelectNone') }}</a></li>
                        </ul>
                    </div>
                </div>
            </nav>
        </div>
        <div class="middle-content">
            <div class="tab-content infoboard-content" id="infoboard-content"></div>
        </div>
        <div class="bottom-content">
            <div class="tab-content infoboard-content" id="infoboard-view" style="display: none;"></div>
        </div>
    </div>
</div>
</template>

<script>
import { i18nMixin, momentMixin } from '../modules/shared/mixins';
import { App } from '../scripts/app';
import dialog from '../scripts/core/dialog';
import { CONFIG } from '../config';
import templates from '../scripts/core/templates';
import api from '../scripts/api';
import AuthService from '../services/authservice';
import Workspace from '../scripts/workspaces';
import { ContextEnum } from '../enuns/context.enum';
import NavbarOverflow from '../modules/shared/components/navbar-overflow/navbar-overflow.component.vue';
import { NAVBAR_OVERFLOW_ITEMS, isNavbarItemEnabled } from '../modules/shared/components/navbar-overflow/navbar-overflow.helper';

const infoBoard = () => require('../scripts/core/infoboard').default;

const NAVBAR_FIT_STEPS = ['navbar-no-logo', 'navbar-collapsed', 'navbar-compact-search'];

export default {
  computed: {
    language() {
        return this.getCurrentLanguage().split('-')[0];
    }
  },

  data() {
    return {
      apikey: sessionStorage.getItem('token'),
      user: sessionStorage.getItem('username'),
      neodashUrl: `${CONFIG.URL.NEODASH_HOST}?language=${localStorage.getItem('language') || localStorage.getItem('i18nextLng')}`,
      linkManualUrl: CONFIG.URL.MANUAL_URL,
    };
  },

  components: { NavbarOverflow },

  mixins: [i18nMixin, momentMixin, AuthService],

  methods: {
    drawRectangle() {
      $('.leaflet-draw-draw-rectangle')[0].click();
    },

    drawCircle() {
      $('.leaflet-draw-draw-circle')[0].click();
    },

    drawPolygon() {
      $('.leaflet-draw-draw-polygon')[0].click();
    },

    saveSnapshot() {
      api.general.log.action(ContextEnum.PanelSuperior, 'Abrir Salvar Sessão');
      dialog.saveSnapshot();
    },

    loadSnapshot() {
      api.general.log.action(ContextEnum.PanelSuperior, 'Caregar Sessão');
      dialog.loadSnapshot();
    },

    openManual(){
      api.general.log.action(ContextEnum.PanelSuperior, 'Manual');
      window.open(this.linkManualUrl, '_blank', 'noopener');
    },

    logout() {
        api.general.log.action(ContextEnum.PanelSuperior, 'Logout');
        AuthService.logout();
    },

    goToBlog() {
      openManual();
    },

    restoreSnapshot() {
      api.general.log.action(ContextEnum.PanelSuperior, 'Carregar Última Sessão');
      Workspace.restoreLastSession();
    },

    fitNavbar() {
      const navbar = this.$refs.navbar;
      if (!navbar) return;

      const hasOverflowItems = NAVBAR_OVERFLOW_ITEMS.some(isNavbarItemEnabled);
      const steps = NAVBAR_FIT_STEPS.filter(step => step !== 'navbar-collapsed' || hasOverflowItems);

      NAVBAR_FIT_STEPS.forEach(step => navbar.classList.remove(step));

      steps.some(step => {
        if (navbar.scrollWidth <= navbar.clientWidth) return true;
        navbar.classList.add(step);
        return false;
      });
    },

  },

  async mounted() {
    $(document).ready(() => {
        const app = new App();
        app.run();
    });

    if (window.ResizeObserver) {
      this.navbarObserver = new window.ResizeObserver(() => this.fitNavbar());
      this.navbarObserver.observe(this.$refs.navbar);
      this.navbarObserver.observe(this.$refs.navbarActions);
    }
  },

  beforeDestroy() {
    if (this.navbarObserver) {
      this.navbarObserver.disconnect();
    }
  },
};
</script>

<style lang="scss" scoped>
/* Extra markup and styles for table-esque vertical and horizontal centering */
.link-change-lang {
    display: flex; 
    align-items: center; 
    justify-content: flex-start; 
    cursor: pointer;
}

.site-wrapper {
  display: table;
  width: 100%;
  height: 100%; /* For at least Firefox */
  min-height: 100%;
  background-color: #34495e;
}

.site-wrapper-inner {
  display: table-cell;
  vertical-align: top;
}

.cover-container {
    margin-top: 13%;
  margin-right: auto;
  margin-left: auto;
}

.inner {
  padding: 30px;
}

.cover {
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  padding: 0 20px;

  p {
    font-size: 14px;
  }

  h2 {
    color: #fff;
  }
}

.mastfoot {
  text-align: center;
  color: rgba(255, 255, 255, 0.5);

  p {
    font-size: 14px;
  }

  a {
    color: #fff;
  }
}

@media (min-width: 768px) {
  /* Pull out the header and footer */
  .mastfoot {
    position: fixed;
    bottom: 0;
  }
  /* Handle the widths */
  .mastfoot,
  .cover-container {
    width: 100%; /* Must be percentage or pixels for horizontal alignment */
  }
}

@media (min-width: 992px) {
  .mastfoot,
  .cover-container {
    width: 800px;
  }
}

    .fa-truck{
        transform: scale(-1, 1);
    }
</style>



// WEBPACK FOOTER //
// src/pages/index.vue